// product page in variant click to sku changes functionality start
document.addEventListener("variant:update", function(e) {
  const variant = e.detail.resource;
  if (!variant) return;

  /* -------------------
      Update SKU
  ------------------- */
  const skuEl = document.querySelector("#ProductSku");
  if (skuEl) {
    skuEl.textContent = variant.sku ? variant.sku : "";
  }

  /* -------------------
        Update Discount Badge
  ------------------- */
  const discountEl = document.querySelector("#ProductDiscount");

  if (discountEl) {
    if (variant.compare_at_price > variant.price) {
      // Calculate discount
      const discount = Math.round(
        ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
      );

      discountEl.style.display = "inline-block";
      discountEl.textContent = `${discount}% OFF`;
    } else {
      // No discount
      discountEl.style.display = "none";
    }
  }
  
  /* -------------------
      Update Tax Note
  ------------------- */
  const taxNote = document.querySelector(".tax-note");

  if (taxNote) {
    if (variant.taxable) {
      taxNote.style.display = "block";
      taxNote.textContent = "(Inclusive of all taxes)";
    } else {
      taxNote.style.display = "none";
    }
  }
});

// readmore to click redirect href section
document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener("click", function (event) {
      const targetId = this.getAttribute("href").replace("#", "");
      const target = document.getElementById(targetId);

      if (target) {
        event.preventDefault();

        // Remove #id from URL so it doesn't appear
        history.replaceState(null, "", window.location.pathname + window.location.search);

        // 50px offset scroll
        const offset = 100;
        const elementTop = target.getBoundingClientRect().top + window.scrollY;
        const finalPosition = elementTop - offset;

        window.scrollTo({
          top: finalPosition,
          behavior: "smooth"
        });
      }
    });
  });

});

  // Accordion Start here
$('.accordion-list > li > .answer').hide();
   
  $('.accordion-list > li').click(function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active").find(".answer").slideUp();
    } else {
      $(".accordion-list > li.active .answer").slideUp();
      $(".accordion-list > li.active").removeClass("active");
      $(this).addClass("active").find(".answer").slideDown();
    }
    return false;
  });
  
document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector("#OpenSizeChart");
  const closeBtn = document.querySelector("#CloseSizeChart");
  const drawer = document.querySelector("#SizeChartDrawer");

  if (openBtn) {
    openBtn.addEventListener("click", () => {
      drawer.classList.add("open");
      document.body.style.overflow = "hidden";
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      drawer.classList.remove("open");
      document.body.style.overflow = "";
    });
  }

  // Close when clicking outside
  document.addEventListener("click", (e) => {
    if (drawer.classList.contains("open")) {
      if (!drawer.contains(e.target) && !openBtn.contains(e.target)) {
        drawer.classList.remove("open");
        document.body.style.overflow = "";
      }
    }
  });
});
